
<div class="wccard p-3 ml--15" style="background-color: #FFFEE5; position: sticky; top: 50px; z-index: 1;" id="topHeader">
  <div class="row">
    <div class="col">
      <div class="d-flex align-items-center justify-content-between">
        <span class="f-18 font-weight-500" style="color: #484B59;" *ngIf="!showFilterComponent">Enter Job Description</span>
        <span class="f-18 font-weight-500" style="color: #484B59;" *ngIf="showFilterComponent">Review Autopilot<sup><span>AI</span></sup> Search Criteria</span>

        <div class="p-1">
          <span class="f-14 font-weight-400" style="color: #969696;">
            <i class="fa-regular fa-lightbulb-on"></i>
            <span class="ml-1">Want help - </span>
            <span class="text-webbtree-green pointer" (click)="learnMoreDetails()">
              Learn More
              <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wccard p-3 ml--15 mb-3" style="margin-top: 1px;">
  <div class="row">
      <div class="col mt-1">
          <span>Project Name<span class="text-danger">*</span></span> <br>
          <input data-testid="auto-app-jd-description-input-1" type="text" class="wc-form-control nobg mt-1" placeholder="Enter project name" [formControl]="projectNameInput"><br>
          <span class="f-12 text-danger mt-1" *ngIf="dublicateProjectNameError">Duplicate project name</span>
          <span class="f-12 text-danger mt-1" *ngIf="projectnameSpecialCharError">Special Character Not Allowed</span>
          <span class="f-12 text-danger mt-1" *ngIf="projectnameRequiredError">Project Name Required</span>
      </div>
  </div>
  <div class="row">
    <div class="col mt-4">
          <div>
            <div class="d-flex align-items-center justify-content-between">
              <span>Enter or Paste a Job Description.<span class="text-danger">*</span></span>

                  <div class="ats-upload-btn d-flex justify-content-center align-items-center pointer">
                    <div *ngIf="!isUploadedFileCorrect" class="text-center">
                      <div class="pointer" *ngIf="!jdDataLoading" >
                        <p class="font-weight-600 text-bluex mb-0">
                          <i class="fa-regular fa-upload mr-1"></i>Upload JD
                        </p>
                      </div>
                    </div>

                    <input data-testid="auto-app-jd-description-input-2" *ngIf="!isUploadedFileCorrect" type="file" #document (change)="uploadFile($event)"
                      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                    <p *ngIf="jdDataLoading" [ngClass]="{ 'spinner-border text-blue spinner-size': jdDataLoading }"
                      [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
                    </p>

                    <div class="text-center d-flex" style="margin-right: 100px;" *ngIf="isUploadedFileCorrect && !jdDataLoading">

                      <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                      <p class="f-14 font-weight-600 text-webbtree-green text-truncate" style="width: 100px;">{{ uploadedFilename }}</p>
                      <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove</p>
                    </div>

                  </div>
            </div>

            <textarea data-testid="auto-app-jd-description-textarea-1" class="wc-form-control nobg mt-1" style="height: 200px;" [formControl]="jdInput"
              placeholder="Enter or Paste a Job Description"></textarea>
            <br>
            <span class="f-12 font-weight-400 text-danger" *ngIf="jdInputError">
              <i class="fa-solid fa-circle-info"></i>
              <span class="text-danger">Enter or Paste a Job Description to proceed further</span>
            </span>

            <div class="d-flex justify-content-between align-items-center">
              <div class="">
                <!-- <span class="f-14 font-weight-400" style="color: #969696;">Dont have a Job Description?</span>
                <span class="f-14 font-weight-400 ml-2 pointer" style="color: #2E93A1;" (click)="enterManually()">Enter Details Manually</span> -->
              </div>

              <div>
                <button data-testid="auto-app-jd-description-button-1" class="btn-trms-medium w-100 mt-6"
                  [ngClass]="{ 'bg-gray': !projectNameInput.value || projectNameInputError || dublicateProjectNameError || jdInputError || !changedJD,  'text-center': showSubmitJdSpinner }"
                  (click)="submitJD()"
                  [disabled]="showSubmitJdSpinner || projectNameInputError || dublicateProjectNameError || jdInputError || !changedJD">
                  <span [ngClass]="{ 'spinner-border text-white spinner-size': showSubmitJdSpinner }"
                    [ngStyle]="{ 'width: 20px; height: 20px;': showSubmitJdSpinner }">
                    {{showSubmitJdSpinner ? '' : 'Submit'}}
                  </span>
                </button>
              </div>
            </div>
          </div>
    </div>
  </div>

  <!-- JD Filter Section  -->
  <div class="row" id="filterC" *ngIf="showFilterComponent">
    <div class="col">
      <div class="mt-2 mb-2 holding" style="height: 200px;">
        <div class="mb-4">
          <div class="webbtree-ai">Webbtree Autopilot<sup class="landing"><span>AI</span></sup> Matchmaking</div>
          <span class="f-12 font-weight-600">Webbtree Autopilot<sup style="top:-1px!important;"><span>AI</span></sup> has parsed your Job Description</span>
        </div>
        <div>
          <p class="confirm-banner">✅ Confirm Job Title, Location, and Skills.</p>
          <p class="confirm-banner">✅ Check other parameters to help Webbtree AI target the best matches.</p>
          <p class="confirm-banner">✅ Hit Submit to set Autopilot<sup style="top:-1px!important;"><span>AI</span></sup> Evaluation Criteria</p>
        </div>

        <p class="f-14 font-weight-600 f-12" style="margin-top: 16px;">💡 Want help? <a data-testid="auto-app-jd-description-a-1" style="color: #5CD9EA;" (click)="learnMoreDetails()">Read our quick blog guide <i class="fa-solid fa-arrow-right"></i></a></p>
      </div>
      <app-jd-filter [jobdescription]="jdInput.value" [projectname]="projectNameInput.value" [changedJD]="changedJD" [dublicateProjectNameError]="dublicateProjectNameError" [projectnameSpecialCharError]="projectnameSpecialCharError"></app-jd-filter>
    </div>
  </div>
</div>
